import React from 'react';

import SignupEntry from './../../components/shop/SignupEntry.js';

export default class WorkshopSignup extends React.Component {
    constructor() {
        super()

        this.state = { 
            people: [ {name:''} ] 
        };
    }

    add() {
        this.state.people.push(
            {name: ''}
        );
        this.setState(this.state);
    }

    update(key, name) {
        var people = [...this.state.people];
        people[key].name = name;
        this.setState({people});
    }

    remove(key) {
        if (this.state.people.length === 1) {
            // prevent all entries from being removed
            return;
        }

        this.state.people.splice(key, 1);
        this.setState(this.state);
    }

    reset() {
        if (window.confirm("Are you sure?")) {
            this.setState({
                people: [ {name:''} ]
            });
        }
    }

    render() {
        var entries = this.state.people.map((person, index) => {
            return (
                <SignupEntry 
                    key={index} 
                    index={index} 
                    person={person} 
                    update={this.update.bind(this)} 
                    remove={this.remove.bind(this)} />
            );
        });

        return (
            <div>
                <div>
                {entries}
                </div>
                <div id="workshop-actions" className="form-group">
                    <input type="button" className="btn btn-success btn-sm attendee-add" onClick={this.add.bind(this)} value="Add Attendee" />
                    <input type="button" className="btn btn-warning btn-sm attendee-reset" onClick={this.reset.bind(this)} value="Reset" />
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/shop/WorkshopSignup.js